import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'simpleTime'
})
export class SimpleTimePipe implements PipeTransform {

  transform(date: any ): string {

    if(!date) return null;
    
    let aMpM = 'AM';
    let d = this.isDate(date)?date: new Date(date);
    let hr = d.getHours();
    if(hr>11){ aMpM='PM';hr=hr-12;}
    hr=hr==0?hr=12:hr;

    let hour = hr.toString().padStart(2, "0");
    let min = d.getMinutes().toString().padStart(2, "0");;
    let hrmin = hour+':'+min + ' ' +aMpM;
    return hrmin;

  }

  isDate (x:any) 
  { 
    return (null != x) && !isNaN(x) && ("undefined" !== typeof x.getDate); 
  }

}
